
import { SWRConfiguration, SWRResponse } from "swr";

import { IReturn, QueryConfigurationParticipants, QueryConfigurationParticipantsResponse, ConfigurationParticipant } from "@/api/dtos";
import { useMemo } from "react";
import useGet from "@/hooks/api/useGet";

const getData = (response?: SWRResponse<QueryConfigurationParticipantsResponse, QueryConfigurationParticipantsResponse>) => response?.data?.data?.find(x => true);
const getError = (response?: SWRResponse<QueryConfigurationParticipantsResponse, QueryConfigurationParticipantsResponse>) => (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = (response?: SWRResponse<QueryConfigurationParticipantsResponse, QueryConfigurationParticipantsResponse>) => ({});

export const useConfigurationParticipant = (query?: Partial<ConfigurationParticipant>, configuration?: SWRConfiguration | undefined) => {
    const request = useMemo(() => {
        if (!query) {
            return undefined;
        }

        return () => {
            return new QueryConfigurationParticipants(query);
        }
    }, [query]);

    return useGet(request, { getData, getError, getAdditionalState }, configuration);
}

export default useConfigurationParticipant;